/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TextActionCheckIcon16Light = forwardRef('TextActionCheckIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M2 3.5a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5Z" }),
        React.createElement("path", { d: "M2.5 7a.5.5 0 0 0 0 1h11a.5.5 0 0 0 0-1h-11Z" }),
        React.createElement("path", { d: "M2.5 11a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1h-4Z" }),
        React.createElement("path", { d: "m11.707 14.5 3.147-3.146a.5.5 0 0 0-.708-.708L11 13.793l-1.646-1.647a.5.5 0 0 0-.708.708l1.647 1.646a1 1 0 0 0 1.414 0Z" })));
});
